module.exports = __webpack_public_path__ + "img/default-head.10b35d45.jpg";